angular.module('app').filter('date', function() {
    return function(listing) {
    	if(!listing) return listing;
        var trace = angular.trace;
    	var results = listing.concat();

        results.sort(function(a,b){
        	return parseInt(a.date) > parseInt(b.date) ? 1 : -1;
        });
    	return results;
    };
});